if (!customElements.get('suv-style-finder')) {
  customElements.define('suv-style-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-svf-labels]').textContent);
      this.form = this.querySelector('[data-svf-form]');
      this.market = this.querySelector('[data-svf-market]');
      this.brand = this.querySelector('[data-svf-brand]');
      this.model = this.querySelector('[data-svf-model]');
      this.year = this.querySelector('[data-svf-year]');
      this.status = this.querySelector('[data-svf-status]');
      this.searchButton = this.querySelector('[data-svf-search]');
      this.result = this.querySelector('[data-svf-result]');
      this.contact = this.querySelector('[data-svf-contact]');
      this.manual = this.querySelector('[data-svf-manual]');
      this.email = this.querySelector('[data-svf-email]');
      this.market.addEventListener('change', () => this.updateBrands());
      this.brand.addEventListener('change', () => this.updateModels());
      this.model.addEventListener('change', () => this.updateYears());
      this.year.addEventListener('change', () => this.clearResult());
      this.form.addEventListener('submit', event => { event.preventDefault(); this.findStyle(); });
      this.querySelector('[data-svf-missing]').addEventListener('click', () => this.openManual());
      this.querySelector('[data-svf-confirm]').addEventListener('click', () => this.openContact());
      this.contact.addEventListener('input', () => this.updateEmail());
      this.contact.addEventListener('change', () => this.updateEmail());
      this.email.addEventListener('click', event => {
        this.updateEmail();
        if (!this.validateContact()) event.preventDefault();
      });
      this.loadCatalog();
    }

    async loadCatalog() {
      this.status.textContent = this.labels.loading;
      this.searchButton.disabled = true;
      try {
        const response = await fetch(this.dataset.catalogUrl, { credentials: 'omit' });
        if (!response.ok) throw new Error('catalog');
        const payload = await response.json();
        if (!Array.isArray(payload.vehicles) || payload.version !== 1) throw new Error('catalog');
        this.vehicles = payload.vehicles;
        this.searchButton.disabled = false;
        this.status.textContent = '';
        this.updateBrands();
      } catch {
        this.status.textContent = this.labels.catalog_error;
        this.searchButton.disabled = true;
      }
    }

    setOptions(element, entries, placeholder) {
      element.replaceChildren(new Option(placeholder, ''));
      entries.forEach(item => element.add(new Option(item.label, item.value)));
      element.disabled = entries.length === 0;
    }

    clearResult() {
      this.selection = null;
      this.querySelector('[data-svf-empty]').hidden = false;
      this.querySelector('[data-svf-found]').hidden = true;
      this.querySelector('[data-svf-contact]').hidden = true;
      this.querySelector('[data-svf-form-error]').textContent = '';
      this.result.removeAttribute('data-active');
      ['length', 'width', 'height', 'seats'].forEach(key => { this.querySelector(`[data-svf-${key}]`).value = ''; });
      this.querySelector('[data-svf-contact-error]').textContent = '';
      this.email.removeAttribute('href');
    }

    updateBrands() {
      this.clearResult();
      const values = [...new Set((this.vehicles || []).filter(row => row.market === this.market.value).map(row => row.brand))].sort((a, b) => a.localeCompare(b));
      this.setOptions(this.brand, values.map(value => ({ label: value, value })), this.labels.select_brand);
      this.setOptions(this.model, [], this.labels.select_model);
      this.setOptions(this.year, [], this.labels.select_year);
    }

    updateModels() {
      this.clearResult();
      const rows = (this.vehicles || []).filter(row => row.market === this.market.value && row.brand === this.brand.value).sort((a, b) => a.model.localeCompare(b.model));
      this.setOptions(this.model, rows.map(row => ({ label: row.model, value: row.id })), this.labels.select_model);
      this.setOptions(this.year, [], this.labels.select_year);
    }

    updateYears() {
      this.clearResult();
      const row = (this.vehicles || []).find(row => row.id === this.model.value);
      const years = row ? [...row.years].sort((a, b) => b - a) : [];
      this.setOptions(this.year, years.map(year => ({ label: String(year), value: String(year) })), this.labels.select_year);
    }

    findStyle() {
      const row = (this.vehicles || []).find(vehicle => vehicle.id === this.model.value);
      if (!row || row.market !== this.market.value || row.brand !== this.brand.value || !row.years.includes(Number(this.year.value))) {
        this.querySelector('[data-svf-form-error]').textContent = this.labels.select_vehicle;
        return;
      }
      this.selection = { ...row, selectedYear: this.year.value };
      const hasStyle = row.category === 'large' && row.style === 'L' && Boolean(this.dataset.productUrl);
      this.querySelector('[data-svf-empty]').hidden = true;
      this.querySelector('[data-svf-found]').hidden = false;
      this.querySelector('[data-svf-vehicle]').textContent = `${row.brand} ${row.model} · ${this.year.value}`;
      this.querySelector('[data-svf-category]').textContent = this.labels[`${row.category}_name`];
      this.querySelector('[data-svf-result-heading]').textContent = hasStyle ? this.labels.result_heading : this.labels.no_style_heading;
      this.querySelector('[data-svf-result-intro]').textContent = hasStyle ? this.labels.result_intro : this.labels.no_style_intro;
      this.querySelector('[data-svf-table-category]').textContent = this.labels[`${row.category}_name`];
      this.querySelector('[data-svf-table-style]').textContent = hasStyle ? 'L' : '—';
      this.querySelector('[data-svf-table-grade]').textContent = row.grade || '—';
      this.querySelector('[data-svf-specific-guide]').textContent = this.labels[`${row.category}_detail`];
      this.querySelector('[data-svf-product]').hidden = !hasStyle;
      this.querySelector('[data-svf-view-product]').hidden = !hasStyle;
      this.manual.hidden = true;
      this.contact.hidden = hasStyle;
      this.result.setAttribute('data-active', 'true');
      this.querySelector('[data-svf-form-error]').textContent = '';
      this.updateEmail();
      this.querySelector('[data-svf-result-heading]').focus({ preventScroll: true });
      this.result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }

    openManual() {
      this.clearResult();
      this.manual.hidden = false;
      this.contact.hidden = false;
      const row = (this.vehicles || []).find(vehicle => vehicle.id === this.model.value);
      this.querySelector('[data-svf-manual-brand]').value = this.brand.value;
      this.querySelector('[data-svf-manual-model]').value = row ? row.model : '';
      this.querySelector('[data-svf-manual-year]').value = this.year.value;
      this.openContact();
    }

    openContact() {
      this.contact.hidden = false;
      this.updateEmail();
      this.contact.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const input = this.manual.hidden ? this.querySelector('[data-svf-length]') : this.querySelector('[data-svf-manual-brand]');
      input.focus({ preventScroll: true });
    }

    contactValues() {
      const row = this.selection;
      const get = key => this.querySelector(`[data-svf-${key}]`).value.trim();
      return {
        market: this.market.options[this.market.selectedIndex]?.textContent || '',
        brand: row ? row.brand : get('manual-brand'),
        model: row ? row.model : get('manual-model'),
        year: row ? row.selectedYear : get('manual-year'),
        length: get('length'), width: get('width'), height: get('height'), seats: get('seats'), unit: get('unit'),
        category: row ? this.labels[`${row.category}_name`] : '',
        style: row?.style || ''
      };
    }

    validateContact() {
      const v = this.contactValues();
      const fields = ['length', 'width'];
      let valid = Boolean(v.brand && v.model && /^20\d{2}$/.test(v.year));
      for (const key of fields) {
        const value = Number(v[key]);
        const input = this.querySelector(`[data-svf-${key}]`);
        const ok = v[key] !== '' && Number.isFinite(value) && value > 0;
        input.setAttribute('aria-invalid', String(!ok));
        valid = valid && ok;
      }
      if (v.height !== '') valid = valid && Number.isFinite(Number(v.height)) && Number(v.height) > 0;
      this.querySelector('[data-svf-contact-error]').textContent = valid ? '' : this.labels.contact_error;
      if (!valid) this.querySelector('[data-svf-contact-error]').scrollIntoView({ block: 'nearest' });
      return valid;
    }

    updateEmail() {
      const v = this.contactValues();
      const unit = v.unit === 'in' ? 'in' : 'cm';
      const lines = [this.labels.email_intro, '', `${this.labels.market}: ${v.market}`, `${this.labels.brand}: ${v.brand}`, `${this.labels.model}: ${v.model}`, `${this.labels.year}: ${v.year}`, `${this.labels.category_column}: ${v.category}`, `${this.labels.style_column}: ${v.style}`, `${this.labels.length}: ${v.length} ${unit}`, `${this.labels.width}: ${v.width} ${unit}`, `${this.labels.height}: ${v.height} ${unit}`, `${this.labels.seats}: ${v.seats}`, '', this.labels.email_outro];
      const subject = `${this.labels.email_subject} — ${[v.brand, v.model, v.year].filter(Boolean).join(' ')}`;
      this.email.href = `mailto:${this.dataset.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
    }
  });
}
